import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";
import { VideoResult } from "common/video/dto/VideoResult";
import { videoFormDefaultValuesGet } from "common/video/video_form_common";
import { useSakusasVideoUpdate } from "hooks/sakusas/video/useSakusasVideoUpdate";
import VideoForm from "components/common/video/VideoForm";
import VideoSingleNav from "components/common/video/VideoSingleNav";

type VideoEditProps = {
  video: VideoResult;
};

const VideoEdit = ({ video }: VideoEditProps) => {
  const { handleSubmit, reset, control, setValue } = useForm({
    defaultValues: videoFormDefaultValuesGet(video),
  });
  const { videoUpdateMutate } = useSakusasVideoUpdate({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_VIDEO_SEARCH],
  });

  const onSubmit = async (data: any) => {
    console.log(data);
    const { datum, title, fileName } = data;
    console.log("datum", datum);
    videoUpdateMutate({
      id: video.id,
      updatePayload: { datum, title, fileName },
    });
    toast.success("Video updated");
  };

  return (
    <DivVideo>
      <VideoForm
        control={control}
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        reset={reset}
        defaultValues={videoFormDefaultValuesGet(video)}
        setValue={setValue}
      />
      <DivNav>
        <VideoSingleNav video={video} hideEditNav={true} />
      </DivNav>
    </DivVideo>
  );
};

const DivVideo = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 1rem;
`;

export default VideoEdit;
